// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__3cXkv","buttons":"Footer_buttons__aCr3U"};